import React, { useState } from 'react'
import getImageUrl from '../functions/getImageUrl';
import image from '../../images/icons-dark-theme/no-image-background.jpg'


const GridItem = ({poster, isMobile = false}) => {
    const [fallbackInUse, setFallback] = useState(false)

    if(poster) {
        const {finalImageURl, imageUrl} = getImageUrl(poster, isMobile, true)
        return (
            <div className="poster-grid-item">
                <img 
                    src={finalImageURl} 
                    alt={'Poster'} 
                    onError={({ currentTarget }) => {
                        if(fallbackInUse) {
                            currentTarget.onerror = null; 
                            currentTarget.src = image;
                        } else {
                            setFallback(true)
                            currentTarget.onerror = null; 
                            currentTarget.src = imageUrl;
                        }
                    }}
                />
            </div>
        )
    } else {
        return (
            <div className="poster-format-item poster-grid-item">
                <div className="picture-wrapper poster-item">
                    <div className="no-image-container">
                        <div className="no-image"></div>
                    </div>
                </div>
            </div>
        )
    }
}

export default GridItem